/**
 * Genesis Event Audio Controller
 *
 * Plays a single combined celebration track.
 */

import celebrationSrc from '@/assets/audio/combined.mp3';
import { errorReporter } from '@/services/errorReportingService';
import useAlertStore from '@/stores/alertStore';

class GenesisAudioController {
  private audio: HTMLAudioElement | null = null;
  private muted = false;

  play(): void {
    if (this.muted) return;
    this.stopAll();
    const audio = new Audio(celebrationSrc);
    audio.volume = 0.8;
    this.audio = audio;
    audio.play().catch((err) => {
      errorReporter.expected('[Genesis Audio] Playback failed', err);
      // Show user-friendly notification
      const showAlert = useAlertStore.getState().showAlert;
      showAlert('Celebration sounds could not play. Check browser autoplay settings.', 'warning');
    });
  }

  stopAll(): void {
    if (this.audio) {
      this.audio.pause();
      this.audio.currentTime = 0;
      this.audio = null;
    }
  }

  setMuted(muted: boolean): void {
    this.muted = muted;
  }
}

export const genesisAudio = new GenesisAudioController();
